import { LayoutProps, Layout } from '@ingka-group-digital/cwds-react-layout';
import { useCallback, useMemo } from 'react';
import useTranslation from '../../hooks/useTranslation';
import { useTypedSelector } from '../../store';
import {
  selectSelectedCountryObject,
  selectUser,
} from '../../store/userData/selectors';
import { changeSelectedLanguage } from '../../store/userData/actionWrappers';
import { useDispatch } from 'react-redux';
import {
  applications,
  returnNavlinks,
  returnSections,
  returnSettingsMenu,
  returnUserObject,
} from './utils';
import { useHistory } from 'react-router-dom';
import { appActions } from '../../store/app/slice';
import AppbarUtilities from '../../common/AppbarUtilities';
import LanguagePicker from '../../common/LanguagePicker';
import ServicePages from '../../common/ServicePages';
import { Stack } from '@mui/material';

const title = 'Expansion Tracker 2.0';

export const IngkaLayout = ({ children }) => {
  const t = useTranslation();
  const dispatch = useDispatch();
  const selectedCountry = useTypedSelector(selectSelectedCountryObject);
  const user = useTypedSelector(selectUser);
  const history = useHistory();

  const settingsList = useMemo(
    () =>
      returnSettingsMenu(user.expansionUserRole, user.permissions, history, t),
    [user],
  );
  const sections = returnSections(t);
  const navItems = useMemo(
    () => returnNavlinks(history, user.expansionUserRole, t),
    [user, selectedCountry],
  );

  const changeSelectedLanguageHandler = (e) => {
    const value = e.target.value;
    if (!value) return;
    dispatch(changeSelectedLanguage(value));
  };
  const logOut = () => dispatch(appActions.signOut());

  const handleLocationChange = useCallback<LayoutProps['onRedirectChange']>(
    async (href, target, event) => {
      event.preventDefault();
      if (href.includes('external')) {
        window.open(href.replace('external', ''));
        return;
      }

      history.push(href);
    },
    [],
  );
  return (
    <Layout
      headerNavMode={'HEADER_LINKS'}
      navItems={navItems}
      isShowingBottomNav={false}
      onRedirectChange={handleLocationChange}
      logoutCallback={logOut}
      user={returnUserObject(user, t)}
      attributes={{
        userProfile: {
          signOut: t('common.signOut'),
        },
        appSwitcher: {
          goToHome: t('common.close'),
        },
      }}
      accessibleApps={applications}
      sections={sections}
      languagePicker={
        <>
          <ServicePages settingsList={settingsList} />
          {/* PPP-468: Temporary hide Language selector*/}
          <Stack display={'none'}>
            <LanguagePicker
              onLanguageChange={changeSelectedLanguageHandler}
              selectedLanguage={selectedCountry}
            />
          </Stack>
        </>
      }
      title={title}
      utilities={<AppbarUtilities />}
      narrowContent={false}
    >
      {children}
    </Layout>
  );
};
